import { jsx, Fragment } from 'react/jsx-runtime';

var IconRenderer = function (_a) {
    var icon = _a.icon, imageComponent = _a.imageComponent, _b = _a.width, width = _b === void 0 ? 24 : _b;
    var ImageComponent = imageComponent !== null && imageComponent !== void 0 ? imageComponent : 'img';
    var iconIsUrl = typeof icon === 'string';
    var renderedIcon = iconIsUrl ? (jsx(ImageComponent, { src: icon, width: width, alt: "" })) : (icon);
    return jsx(Fragment, { children: renderedIcon });
};

export { IconRenderer };
//# sourceMappingURL=IconRenderer.js.map
